import { createStore, combineReducers } from 'redux'

// Session reducer
function sessionReducer(state = { loggedIn: false }, action) {
  switch (action.type) {
    case 'LOGGED':
      return {
        loggedIn: true,
      }
    case 'UNLOGGED':
      return {
        loggedIn: false,
      }
    default:
      return state
  }
}

// User reducer
function userReducer(state = {}, action) {
  switch (action.type) {
    case 'INIT':
      return {
        data: action.data,
      }
    default:
      return state
  }
}

// Server reducer
function serverReducer(state = {}, action) {
  switch (action.type) {
    case 'INIT':
      return {
        data: action.data,
      }
    default:
      return state
  }
}

// Combine all reducers
const rootReducer = combineReducers({
  session: sessionReducer,
  user: userReducer,
  server: serverReducer,
})

// Create the store
const store = createStore(rootReducer)

export default store
